import {
  dispatchEvent,
  createSearch,
  createPage,
  createType,
  createProject,
  createNavigation,
  createDevice,
  createContext,
  createVariations,
  createProduct,
  createUser,
  createOffers,
  createMainOffer,
  createEventID,
  createHasUsed,
  createBuyboxToken,
  createServiceTokens,
  createPickUpStoreOffers,
} from '../helpers';

export const ApolloPageLoadEvent = ({ routerProps, client, body }) => {
  if (typeof window !== 'undefined') {
    dispatchEvent('page:load', createPageLoadBody({ routerProps, client, body }));
  }
};

const createPageLoadBody = ({ routerProps, client, body }) => ({
  page: createPage({ routerProps, client, body }),
  type: createType({ routerProps, client, body }),
  project: createProject({ routerProps, client, body }),
  device: createDevice({ client }),
  navigation: createNavigation(),
  context: createContext({ client }),
  search: createSearch({ routerProps, client, body }),
  variations: createVariations({ routerProps, client, body }),
  product: createProduct({ routerProps, client, body }),
  user: createUser({ client }),
  pickUpStoreOffers: createPickUpStoreOffers({ body }),
  mainOffer: createMainOffer({ routerProps, client, body }),
  offers: createOffers({ routerProps, client, body }),
  eventID: createEventID(),
  hasUsed: createHasUsed({ routerProps, client, body }),
  buyboxToken: createBuyboxToken({ routerProps, body }),
  serviceTokens: createServiceTokens({ routerProps, client, body }),
});
